import type { ExperienceState } from "@/types/state";
import { sanitizeHtml } from "@/modules/sanitizeHtml";

interface MethodArticle {
  title?: string;
  subtitle?: string;
  description?: string;
  titleImage?: { filename?: string };
}

type MethodDetailsProps = {
  experienceState: ExperienceState;
  article?: MethodArticle | null;
  className?: string;
};

export default function MethodDetails({
  experienceState,
  article,
  className,
}: MethodDetailsProps) {
  const metadata = experienceState.experienceData.metadata;

  if (article) {
    const title =
      article.titleImage && article.titleImage.filename ? (
        <img
          className="method-title"
          src={metadata.getAssetUrl(article.titleImage.filename)}
          alt={article.title}
        />
      ) : (
        <h1 className="method-title header-1">{article.title}</h1>
      );

    const subtitle = (
      <h2 className="method-subtitle header-2">{article.subtitle}</h2>
    );

    return (
      <div className="method-details-wrapper tw:[.method-shop-window_.articles_&]:flex tw:[.method-shop-window_.articles_&]:flex-col tw:[.method-shop-window_.articles_&]:overflow-auto tw:[.method-shop-window_.articles_&]:[padding:0_16px_0_16px] tw:[.portrait_.method-shop-window_.articles_&]:justify-center">
        {title}
        {subtitle}
        <div className="separator horizontal" />
        <div
          className="method-description tw:[.method-shop-window_.articles_&]:mt-[10px]"
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(article.description ?? ""),
          }}
        />
      </div>
    );
  }
  return <div className={className} />;
}
